import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit, Input, ViewEncapsulation,Pipe  } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { CompanyOffersService } from "app/company-offers/services/company-offers.service";
import { ICompanySpecificInfo } from "app/company-offers/services/icompany-specific-info";
import * as emiGlobals from 'app/globals';
import { LoanOfferGenService } from "app/loan/services/loan-offer-gen.service";
import { NgbCarousel } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'cs-persoanl-loan-form',
  templateUrl: './cs-persoanl-loan-form.component.html',
  styleUrls: ['./cs-persoanl-loan-form.component.css']
})
export class CsPersoanlLoanFormComponent implements OnInit {
  defaultQuoteLoanAmount = "1,00,000";
  typeOfReducePl;
  @Input() type;
  @Input() otheroffer;
  @Input() pageData;
  isAddpostion: false;

  hide_personalize=true;
  more_personalize_mobile=false;
  x=true;
  loanApplyForm : FormGroup;
  companyInfo:ICompanySpecificInfo;

  value = 30;
  show_Loan_TextExit=false;
  more_personalize:boolean=false;
  title="Personalise my offers.";
  hide_on_mobile:boolean=true;
  hide_on_desktop:boolean=true;
  loan_amount_generated=false;

  loan_amount_label ="Loan Amount";
  options_locations=this.loanOfferService.getCityList();
  options_bank=this.loanOfferService.getBankList();
  // options_bank = emiGlobals.SalaryBankEnum;
  options_gender = emiGlobals.GenderEnum;
  option_loan_tenure = emiGlobals.PLLoanTenureEnum;
  option_workexp = emiGlobals.WorkExperienceEnum;


  
  q_type   = "enquiry";
  q_amount   = false;
  q_l_type   = this.type;
  dataToApi; 


  constructor(
    private fb: FormBuilder,
    private companyOffersService:CompanyOffersService,
    private loanOfferService:LoanOfferGenService,
    public router:Router,
    route: ActivatedRoute
  ) { 
    debugger
   this.typeOfReducePl=route.snapshot.data['type'];
    console.log("companyInfo",this.companyInfo);
  }
   

  ngOnInit() {
    this.loanOfferService.checkHasLocalData();
    this.buildForm();
    this.buildText();
    console.log("ng on init this.pageData",this.pageData);
    console.log("companyInfo",this.type);
    this.loanOfferService.updateCustomerInfoData({
              "loan_type":this.type,
    });
   debugger
    if(this.typeOfReducePl == 'personal-loan-transfer'){
      this.loan_amount_label = "Loan Outstanding";
    }
    let formdata=JSON.stringify(this.loanApplyForm.getRawValue());
    let sendingData=JSON.parse(formdata);
    this.submitForm(sendingData);
  }

  ngOnChange(){
  }

  buildForm(){

    this.loanApplyForm = this.fb.group({
      'netsalary': [this.getFielsDefaultValue('netsalary',this.pageData.pl_netsalary), Validators.compose([Validators.required, Validators.minLength(3)])],
      'existingemi':[this.getFielsDefaultValue('existing_emi',this.pageData.pl_emi), Validators.compose([Validators.required])],
      'salarybankaccount':[this.getFielsDefaultValue('salary_bank_account_id',this.pageData.salarybank), Validators.compose([Validators.required])],
      'workexp':[this.pageData.workexp_id, Validators.compose([Validators.required])],
      'age':[this.getFielsDefaultValue('age',this.pageData.pl_age), Validators.compose([Validators.required])],
      'location':[this.getFielsDefaultValue('location_id',this.pageData.location), Validators.compose([Validators.required])],
      'gender':[this.getFielsDefaultValue('gender_id',this.pageData.gender), Validators.compose([Validators.required])],

      'emp_type':[1, Validators.compose([Validators.required])],
      'employername':[this.pageData.pl_id, Validators.compose([Validators.required])],
      'purp':[this.getTypeSpecificValue('purp'), Validators.compose([Validators.required])],
      'loanamount':[this.pageData.pl_loan_amount, Validators.compose([Validators.required])],
      'loantenure':[this.pageData.pl_tenure, Validators.compose([Validators.required])],
    });

  }

  buildText(){
    if(this.type == emiGlobals.PersonalLoan_New){
      this.title = "Personalise my offers.";
    }else{
      this.title = "Personalise my offers."; 
    }
  }

  showForm(){
    this.hide_on_mobile=false;
  }
  // Show Age, Gender and Work exp form : Show / Hide
  updatePersonalize(value){
    this.more_personalize = !this.more_personalize;
    this.isAddpostion = value;
  }
  updatePersonalizeMobile(value){
    this.x=false;
    this.hide_personalize=false;
    this.more_personalize_mobile=value;
    
    // this.carouselindicators.next();
  }

  submitForm(values){
    debugger
    console.log(this.type);
    console.log(values);
    // let queryData={
    //   loanamount          :values.loanamount,
    //   loan_tenure_id      :values.loantenure,
    //   netsalary           :values.netsalary,
    //   emi                 :values.existingemi,
    //   bank_id             :values.salarybankaccount,
    //   work_exp_id         :values.workexp,
    //   gender_id           :values.gender,
    //   location_id         :values.location,
    //   age                 :values.age,
    //   generate_quote      :true,
    // };
    // if(this.typeOfReducePl=='personal-loan-transfer'){
    //   this.router.navigate(['/company/'+this.pageData.company_url+'/reduce-personal-loan'],{
    //     queryParams:queryData
    //    }); 
    // }if(this.typeOfReducePl=='personal-loan'){
    //   this.router.navigate(['/company/'+this.pageData.company_url+'/personal-loan'],{
    //     queryParams:queryData
    //    }); 
    // }


    console.log(values.workexp);
    console.log(this.option_workexp[values.workexp]);

    this.q_type     = "enquiry";
    this.q_amount   = values.loanamount;
    this.q_l_type   = (this.type==emiGlobals.PersonalLoan_New?"New Loan" : "Balance Transfer");
    let dataToApi           = Object.assign({}, values);
    try {
      this.loanOfferService.updateCustomerInfoData(
          {
            "loan_amount":values.loanamount,
            "loan_tenure":this.option_loan_tenure[values.loantenure].name,
            "netsalary":values.netsalary,
            "existing_emi":values.existingemi,
            "salary_bank_account":this.options_bank[values.salarybankaccount].name,
            "salary_bank_account_id":values.salarybankaccount,
            "work_exp":this.option_workexp[0].name,
            "gender":this.options_gender[values.gender].name,
            "gender_id":values.gender,
            "location":this.options_locations[values.location].name,
            "work_exp_id":values.workexp,
            "location_id":values.location,
            "loan_type":this.type,
          }
      );
      console.log(values);
      console.log("bank acc",this.options_bank[values.salarybankaccount]);

      dataToApi.salarybankaccount = this.options_bank[values.salarybankaccount].value;
      dataToApi.loantenure        = this.option_loan_tenure[values.loantenure].value;
      dataToApi.workexp           = this.option_workexp[values.workexp].value;
      dataToApi.location          = this.options_locations[values.location].value;
      dataToApi.gender            = this.options_gender[values.gender].value;
      dataToApi.loan_type         = this.type;

      this.dataToApi = dataToApi;
      this.loan_amount_generated  = true;

      dataToApi.purp              = this.getTypeSpecificValue('purp');
      dataToApi.pid               = this.getPid('newloan');
      this.loanOfferService.generateOffer(dataToApi);
      this.more_personalize =true;
      
    } catch (error) {
      console.log(error);
    }
  }

  getFielsDefaultValue(field,defaultvalue=null){
    var data = this.loanOfferService.getLocalCustomerInfoData(field);
    return (data?data:defaultvalue);
  }

  getTypeSpecificValue(field):number{
  debugger
    switch(this.type){
      case emiGlobals.PersonalLoan_New:
        switch(field){
          case 'purp': {  return 1; }
        }
      break;
      case emiGlobals.PersonalLoan_Transfer:
        switch(field){
          case 'purp': {  return 6; }
        }
      break;
    }
  }


  getPid(tag):number {
    let purp  = this.type;
    let pid = 1;

    //Salaried New loan
         if(tag!="eligibiliity" && purp == emiGlobals.PersonalLoan_New){ pid = 1; }
    else if(tag=="eligibiliity" && purp == emiGlobals.PersonalLoan_New){ pid = 2; }
    // Balance Transfer
    else if(tag!="eligibiliity" && purp == emiGlobals.PersonalLoan_Transfer ){ pid = 7; }
    else if(tag=="eligibiliity" && purp == emiGlobals.PersonalLoan_Transfer ){ pid = 7; }
    
    return pid;
  }


  eligibiliityCheck(amount){
    this.q_type   = "income";
    this.q_amount   = amount;
    this.q_l_type   = (this.type==emiGlobals.PersonalLoan_New?"New Loan" : "Balance Transfer");

    console.log("values",this.dataToApi);
    this.dataToApi.loanamount   = amount;
    this.dataToApi.loan_type    = this.type;
    this.dataToApi.purp         = this.getTypeSpecificValue('purp');
    this.dataToApi.pid          = this.getPid('eligibiliity');
    this.loanOfferService.generateOffer(this.dataToApi);
  }
  

}



// WEBPACK FOOTER //
// ./src/app/company-offers/cs-persoanl-loan-form/cs-persoanl-loan-form.component.ts